module.exports = __webpack_public_path__ + "media/features/use-cases/images/image_en@2x-31f2ab90ccaaf56e57132acfa65070e6.png";